/* ===== Paper Dolls Gown Builder ===== */
console.log('[PD] gown-builder.js loaded');

/* tiny helpers */
const $  = (sel, root = document) => (root || document).querySelector(sel);
const $$ = (sel, root = document) => Array.from((root || document).querySelectorAll(sel));
const isRetailerMode = true;


/* ---------- BUILDER INIT ---------- */
async function initBuilder(root = document) {
  const pdRoot = $('.pd-builder', root);
  if (!pdRoot) { console.warn('[PD] no .pd-builder — skipping'); return; }

  const builderRoot = pdRoot; // convenience alias for view toggling
  builderRoot.classList.add('pd-view-products'); // default state

  document.documentElement.classList.add('is-builder-page');
  document.body.classList.add('is-builder-page');

  // cache (scoped to builder)
  const previewStack     = $('#preview-stack', pdRoot);
  const totalPriceEl     = $('#builder26-total-price', pdRoot);
  const priceEl          = $('#builder26-price', pdRoot);
  const variantIdInput   = $('#builder26-variant-id', pdRoot);
  const summaryInput     = $('#builder26-summary-input', pdRoot);
  const selectionDetails = $('#builder26-selection-details', pdRoot);
  const addToCartBtn     = $('.AddtoCart', pdRoot);

  const tabsRow          = $('#builder26-tabs', pdRoot) || $('.builder26-tabs', pdRoot);
  const tabs             = $$('.builder26-tab', tabsRow || pdRoot);
  const productContainer = $('#builder26-options', pdRoot);
    const variantContainer = $('#builder26-variant-options', pdRoot);
    const productGrid = productContainer?.querySelector('[data-pd-cards]');

 if (!tabsRow || !tabs.length || !productContainer || !variantContainer || !productGrid) {
  console.warn('[PD] required builder markup missing — abort init');
  return;
}
  /* ================================
     Colorways toggle: UI state only
     ================================ */
  const colorwaysToggle = document.getElementById('pdShowAllColorways');

    // --- Colorways toggle state (default: Traditional neutrals only) ---
let pdShowAllColorways = false;
  function setShowAllColorways(on) {
    // class lives on the builder root so CSS + other modules can react
    builderRoot.classList.toggle('pd-show-all-colorways', !!on);

// ✅ NEW: highlight active label (both labels always visible)
  const toggleWrap = builderRoot.querySelector('[data-pd-colorways-toggle]');
  const labelWhite = toggleWrap?.querySelector('.pd-toggle-label--white');
  const labelAll = toggleWrap?.querySelector('.pd-toggle-label--all');

  if (labelWhite && labelAll) {
    labelWhite.classList.toggle('is-active', !on);
    labelAll.classList.toggle('is-active', !!on);
  }

    // re-apply “limit” after cards render (safe no-op if markup differs)
    applyColorwayLimitToAllCards();
  }

  function applyColorwayLimitToAllCards() {
    // If your swatches are injected, run after any collection load
    const cardsRoot = productContainer.querySelector('[data-pd-grid]') || productContainer.querySelector('[data-pd-cards]');
    if (!cardsRoot) return;

    const showAll = builderRoot.classList.contains('pd-show-all-colorways');
    const LIMIT = 6; // tweak to taste

    cardsRoot.querySelectorAll('.builder26-option-card').forEach((card) => {
      // Try a few common swatch selectors (won't break if none exist)
      const swatches =
        card.querySelectorAll('[data-pd-swatch], .pd-swatch, .pd-swatch-item, .swatch, .swatch-item');

      if (!swatches || !swatches.length) return;

      swatches.forEach((el, idx) => {
        // don’t hide a “+ more” label if you use one; only hide actual swatches
        el.hidden = (!showAll && idx >= LIMIT);
      });

      // If you have a "+ more" element, show it only when we’re hiding extras
      const more =
        card.querySelector('[data-pd-more], .pd-more, .pd-swatch-more, .swatch-more');

      if (more) {
        more.hidden = showAll;
      }
    });
  }

  // initialize from checkbox state
  if (colorwaysToggle) {
    setShowAllColorways(colorwaysToggle.checked);
    colorwaysToggle.addEventListener('change', (e) => {
      setShowAllColorways(e.target.checked);
    });
  }


// Reveal builder once init has confirmed required markup exists
document.getElementById('pdBuilderShell')?.classList.add('pd-ready');

  /* state */
  const selections = {};
  window.PaperDolls = window.PaperDolls || {};
window.PaperDolls.selections = selections; // debug: expose selections for console
  let baseProductVariantId = null;


// Keep this list small + explicit. Edit names to match Shopify exactly.
const PD_NEUTRAL_COLORS = new Set([
  'ivory', 'white', 'crystal', 'stephanotis', 'magnolia',
  'nude', 'light nude', 'mocha', 'chocolate'
]);

function pdNorm(str) {
  return String(str || '').trim().toLowerCase();
}

function getColorOptionIndex(product) {
  // product.options is usually like: [{name:'Waistline'}, {name:'Color'}]
  if (!product || !Array.isArray(product.options)) return -1;
 const idx = product.options.findIndex(o => pdNorm(o && (o.name || o)).includes('color'));
  return idx; // 0,1,2... or -1 if not found
}

function variantColorValue(product, v) {
  const idx = getColorOptionIndex(product);
  if (idx < 0) return '';
  // variants from product.json often have v.option1/v.option2/v.option3
  if (idx === 0) return v.option1 || '';
  if (idx === 1) return v.option2 || '';
  if (idx === 2) return v.option3 || '';
  return '';
}

function pdFindOptionIndex(product, targetName) {
  const opts = product?.options || [];
  const t = (targetName || '').toLowerCase();

  const idx = opts.findIndex(o => (o || '').toLowerCase() === t);
 return opts.findIndex(o => {
  const name = (typeof o === 'string')
    ? o
    : (o && typeof o === 'object' ? (o.name || o.title || '') : '');

  return String(name).toLowerCase() === t;
});

}

function pdVariantValueByIndex(variant, idx) {
  if (idx === 0) return variant?.option1 || '';
  if (idx === 1) return variant?.option2 || '';
  if (idx === 2) return variant?.option3 || '';
  return '';
}

function pdGetOptionValueByName(product, variant, optionName) {
  const idx = pdFindOptionIndex(product, optionName);
  if (idx === -1) return '';
  return pdVariantValueByIndex(variant, idx);
}

/**
 * Builds a human label like:
 * - "Crepe • Ivory" (fabric + color)
 * - "Ivory" (color only)
 * - "Crepe" (fabric only)
 * - fallback to variant.title if nothing else is found
 */
function pdBuildVariantLabel(product, variant) {
  const fabric = pdGetOptionValueByName(product, variant, 'Fabric');
  const color  = pdGetOptionValueByName(product, variant, 'Color');

  // Only include non-empty pieces
  const parts = [];
  if (fabric) parts.push(fabric);
  if (color) parts.push(color);

  if (parts.length) return parts.join(' • ');

  // Fallbacks for products that don't use "Fabric"/"Color" names:
  // If there's exactly 1 option, show option1.
  if (variant?.option1 && !variant?.option2 && !variant?.option3) return variant.option1;

  // Last resort: variant title
  return variant?.title || 'Variant';
}
function pdFindOptionIndex(product, targetName) {
  const opts = product?.options || [];
  const t = String(targetName || '').toLowerCase();

  return opts.findIndex((o) => {
    let name = '';

    if (typeof o === 'string') {
      name = o;
    } else if (o && typeof o === 'object') {
      name = o.name || o.title || o.label || '';
    }

    return String(name).toLowerCase() === t;
  });
}



function pdVariantValueByIndex(variant, idx) {
  if (idx === 0) return variant?.option1 || '';
  if (idx === 1) return variant?.option2 || '';
  if (idx === 2) return variant?.option3 || '';
  return '';
}

function pdGetOptionValueByName(product, variant, optionName) {
  const idx = pdFindOptionIndex(product, optionName);
  if (idx === -1) return '';
  return pdVariantValueByIndex(variant, idx);
}

//confirmed correct placements
function pdBacksSlotKey(product) {
  const h = String(product?.handle || '').toLowerCase();
  const t = String(product?.title  || '').toLowerCase();

  if (h.includes('backline') || t.includes('backline')) return 'backs_backline';
  if (h.includes('closure')  || t.includes('closure'))  return 'backs_closure';
  if (h.includes('train')    || t.includes('train'))    return 'backs_train';

  // fallback
  if (t.includes('back')) return 'backs_backline';
  return 'backs_misc';
}

function pdBacksSlotLabel(slotKey) {
  switch (slotKey) {
    case 'backs_backline': return 'Backline';
    case 'backs_closure':  return 'Closure';
    case 'backs_train':    return 'Train';
    default:               return 'Back Detail';
  }
}


function pdBacksCardStatus(product) {
  const slotKey = pdBacksSlotKey(product);
  const done = !!selections?.[slotKey]?.id;
  return { slotKey, done };
}


// Tries multiple possible names, returns first hit
function pdGetOptionAny(product, variant, names) {
  for (const n of (names || [])) {
    const val = pdGetOptionValueByName(product, variant, n);
    if (val) return val;
  }
  return '';
}

function pdBacksIsComplete() {
  return !!(selections?.backs_backline?.id &&
            selections?.backs_closure?.id &&
            selections?.backs_train?.id);
}

function pdBacksMissingSlots() {
  const missing = [];
  if (!selections?.backs_backline?.id) missing.push('Backline');
  if (!selections?.backs_closure?.id)  missing.push('Closure');
  if (!selections?.backs_train?.id)    missing.push('Train');
  return missing;
}
const PD_BACK_DEFAULTS = {
  backs_backline: {
    label: 'Classic backline',
    productMatch: 'backline',
    variantMatch: 'Classic'
  },
  backs_train: {
    label: 'Sweep train',
    productMatch: 'train',
    variantMatch: 'Sweep, Regular'
  },
  backs_closure: {
    label: 'Zip closure',
    productMatch: 'closure',
    variantMatch: 'Invisible Center Back Zip'
  }
};



function filterVariantsByColorways(product, variantsList) {
  const before = (variantsList || []).length;

  // If toggle is ON, do not filter
  if (pdShowAllColorways) {
    console.log('[PD] filterVariantsByColorways BYPASS (show all)', {
      product: product?.handle || product?.title,
      pdShowAllColorways,
      before
    });
    return variantsList || [];
  }

  const out = (variantsList || []).filter(v => {
    const raw = variantColorValue(product, v);
    const norm = pdNorm(raw);

    // IMPORTANT: log the actual Set test result
    const setIsSet = (PD_NEUTRAL_COLORS instanceof Set);
    const has = setIsSet ? PD_NEUTRAL_COLORS.has(norm) : false;

    console.log('[PD] filter check', {
      product: product?.handle || product?.title,
      title: v?.title,
      raw,
      norm,
      setIsSet,
      has
    });

    return has;
  });

  console.log('[PD] filterVariantsByColorways RESULT', {
    product: product?.handle || product?.title,
    pdShowAllColorways,
    before,
    after: out.length,
    removed: before - out.length,
    removedTitles: (variantsList || [])
      .filter(v => !out.includes(v))
      .map(v => v.title)
  });

  return out;
}


  const moneyCents = (c = 0) => `$${Math.round(c / 100)}`;
  const activeTabName = () =>
    ($('.builder26-tab.active', tabsRow)?.dataset.tab || 'builder-bodices');

  /* summary & price */
  function recomputeSummary() {
    if (!selectionDetails || !totalPriceEl) return;
    const lines = Object.values(selections).map(sel => {
  const isBase = sel.tab === 'base';

  // Keep your current main label behavior
 const label = isBase
  ? 'Base Rate'
  : `${(sel.tabLabel || pdTabLabel(sel.tab) || '').replace(/:$/, '')}: ${sel.title || ''}`;
  const price = sel.cents ? moneyCents(sel.cents) : '';



  // Build optional extra lines (only if present, and NOT for base)
  const extra = [];
    if (!isBase) {
        if (sel.variantLabel) {
    extra.push(`<div class="builder26-summary-subline">${sel.variantLabel}</div>`);
  }
    if (sel.opt_waist)  extra.push(`<div class="builder26-summary-subline">Waistline: ${sel.opt_waist}</div>`);
    if (sel.opt_fabric) extra.push(`<div class="builder26-summary-subline">Fabric: ${sel.opt_fabric}</div>`);
    if (sel.opt_color)  extra.push(`<div class="builder26-summary-subline">Color: ${sel.opt_color}</div>`);
  }

  return `
    <div class="builder26-summary-item">
      <div class="builder26-summary-line">${label} <span class="price">${price}</span></div>
      ${extra.join('')}
    </div>
  `;
}).join('');

    selectionDetails.innerHTML = lines;
    const total = Object.values(selections)
      .reduce((s, x) => s + (x.cents || 0), 0);
    totalPriceEl.textContent = moneyCents(total);
    if (priceEl) priceEl.textContent = moneyCents(total);
  }

  /* base product (for cart bundle) */
  async function setBaseProduct() {
    try {
      const r = await fetch('/products/paper-dolls-26.js');
      const data = await r.json();
      const base = data?.variants?.[0];
      if (!base) return;
      baseProductVariantId = base.id;
      selections.base = {
        id: base.id,
        title: 'Base Rate',
        tab: 'base',
        cents: base.price || 0,
        preview: ''
      };
      if (variantIdInput) variantIdInput.value = base.id;
      if (summaryInput) {
        summaryInput.value = Object.values(selections)
          .map(s => s.title)
          .join(', ');
      }
      recomputeSummary();
    } catch (_) {
      console.warn('[PD] setBaseProduct failed');
    }
  }

  /* preview layers */
  function clearPreviewForTab(tab) {
    const old = previewStack?.querySelector(`img[data-tab="${tab}"]`);
    if (old) old.remove();
  }
  function pushPreviewLayer({ tab, title, previewUrl }) {
    if (!previewStack || !previewUrl) return;
    clearPreviewForTab(tab);
    const img = new Image();
    img.src = previewUrl;
    img.alt = title;
    img.dataset.tab = tab;
    Object.assign(img.style, {
      position: 'absolute',
      inset: '0',
      width: '100%',
      pointerEvents: 'none',
      zIndex: '10'
    });
    previewStack.appendChild(img);
  }

  /* apply button label — only used on MAGIC tab now */
  function updateApplyButtonText() {
    if (!addToCartBtn) return;
    const label =
      $('.builder26-tab.active', tabsRow)?.textContent.trim() || '';

    if (label === 'MAGIC') {
      addToCartBtn.textContent = 'Review in Cart';
      addToCartBtn.style.display = '';
    } else {
      addToCartBtn.style.display = 'none';
    }
  }

  /* texture → grid background */
  function applyTextureFromActiveTab() {
    const active = $('.builder26-tab.active', tabsRow);
    const url = active?.dataset.texture;
    if (!url || !productContainer) return;
    productContainer.style.setProperty('background-image', `url("${url}")`);
  }

  /* show/hide regions using classes (CSS does the actual display) */
  function showProductsView() {
    builderRoot.classList.add('pd-view-products');
    builderRoot.classList.remove('pd-view-variants');
  }
  function showVariantsView() {
    builderRoot.classList.add('pd-view-variants');
    builderRoot.classList.remove('pd-view-products');
  }

  
/* loaders */
async function loadCollectionProducts(handle) {
  console.log('[PD] loadCollectionProducts START', handle);
 const isBacksCollection = String(handle || '').startsWith('builder-back');
 // BACKS mode flag for CSS (most reliable way to hide stuff)
builderRoot.classList.toggle('pd-backs-mode', !!isBacksCollection);
  showProductsView();

 // Keep topbar (tooltip + toggle) anchored at top
const topbar = productContainer.querySelector('[data-pd-topbar]');
const productGrid = productContainer.querySelector('[data-pd-cards]');

// BACKS: simple instructional copy (topbar helper)
if (topbar) {
  // remove prior helper if present
  topbar.querySelector('[data-pd-backs-help]')?.remove();

  if (isBacksCollection) {
    const help = document.createElement('div');
    help.setAttribute('data-pd-backs-help', '1');
    help.className = 'pd-backs-help';
    help.textContent = 'Choose 1 Backline, 1 Closure, and 1 Train. (All three are required.)';
    topbar.appendChild(help);
  }
  // BACKS: simplify topbar (hide tooltip + toggle, show centered help)
if (topbar) {
  // Toggle + tooltip containers (best-effort selectors; safe if not found)
  const toggleWrap =
    topbar.querySelector('#pdShowAllColorways')?.closest('.pd-toggle-wrap, .pd-toggle, .builder26-toggle, label, .toggle') ||
    topbar.querySelector('#pdShowAllColorways')?.parentElement;

  const tooltipEl =
    topbar.querySelector('[data-pd-tooltip], .pd-tooltip, .builder26-tooltip, .tooltip');

  // Create/update help text
  topbar.querySelector('[data-pd-backs-help]')?.remove();

  if (isBacksCollection) {
    // Hide extras
    if (toggleWrap) toggleWrap.style.display = 'none';
    if (tooltipEl) tooltipEl.style.display = 'none';

    // Add help
    const help = document.createElement('div');
    help.setAttribute('data-pd-backs-help', '1');
    help.className = 'pd-backs-help';
    help.innerHTML = `Choose <strong>1 Backline</strong>, <strong>1 Closure</strong>, and <strong>1 Train</strong>. <span class="pd-backs-help-sub">(All three are required.)</span>`;
    topbar.appendChild(help);

    // Center the whole topbar row for this tab
    topbar.classList.add('pd-backs-topbar');
  } else {
    // Restore for other tabs
    if (toggleWrap) toggleWrap.style.display = '';
    if (tooltipEl) tooltipEl.style.display = '';
    topbar.classList.remove('pd-backs-topbar');
  }
}

}


pdShowAllColorways = !!pdRoot.querySelector('#pdShowAllColorways')?.checked;
// --- Colorways toggle: bind change handler once ---
const colorwaysToggle = pdRoot.querySelector('#pdShowAllColorways');

if (colorwaysToggle && !colorwaysToggle.dataset.pdBound) {
  colorwaysToggle.dataset.pdBound = '1';

  colorwaysToggle.addEventListener('change', async () => {
    pdShowAllColorways = !!colorwaysToggle.checked;
    console.log('TOGGLE changed ->', pdShowAllColorways);

   const activeBtn =
  pdRoot.querySelector('.builder26-tab.active, .builder26-tab.is-active, [data-handle].active, [data-handle].is-active');

const activeHandle =
  activeBtn?.dataset?.handle || activeBtn?.getAttribute('data-handle') || window.pdActiveHandle || '';

if (!activeHandle) {
  console.warn('[PD] Toggle change: could not determine activeHandle');
  return;
}

window.pdActiveHandle = activeHandle; // keep a fallback record
await loadCollectionProducts(activeHandle);


  });
}


if (productGrid) productGrid.innerHTML = '';



  const res  = await fetch(`/collections/${handle}/products.json`);
  const data = await res.json();
  console.log('[PD] loadCollectionProducts DATA', {
  handle,
  status: res.status,
  productCount: (data.products || []).length,
  first: data.products?.[0]?.title
});


  (data.products || []).forEach((p) => {
 // 🔍 Step 1: decide which variants are actually usable
let variantsList = (p.variants || []);

// BACKS collections: builder-backs, builder-backlines, builder-closures, builder-trains
const isBacksTab = String(handle || '').startsWith('builder-back');

// ✅ Only apply "visible variants" gating on NON-backs collections
if (!isBacksTab) {
  if (window.PaperDolls &&
      window.PaperDolls.variants &&
      typeof window.PaperDolls.variants.getVisibleVariants === 'function') {
    variantsList = window.PaperDolls.variants.getVisibleVariants(p);
  }

  // ✅ Only apply color filtering on NON-backs collections
  variantsList = filterVariantsByColorways(p, variantsList);
}



  
    // ⛔ If NO variants have both a thumbnail + preview PNG,
    // skip this product entirely (placeholder in admin only).
   // ⛔ Only skip empty products on NON-backs collections
if (!variantsList.length && !isBacksTab) return;

    

    // 🔧 Build product card
    const card = document.createElement('div');
    card.className = 'builder26-option-card builder-product-trigger';
    card.dataset.productHandle = p.handle;
    card.dataset.productId     = p.id;

    const firstImage = (p.images && p.images[0]?.src) || '';

    // products.json prices are strings in dollars → convert to cents
    const lowestStr = (p.variants && p.variants[0]?.price) || '0';
    const cents     = Math.round(parseFloat(lowestStr) * 100);

    // 🟣 Waistline label: BODICES ONLY, and based on visible variants
    let waistlineLabel = '';
    if (handle === 'builder-bodices') {
      const waistlineSet = new Set();
      variantsList.forEach((v) => {
        if (v.option1) waistlineSet.add(v.option1);
      });
      const waistlineCount = waistlineSet.size || 0;
      waistlineLabel = `${waistlineCount} waistline${waistlineCount === 1 ? '' : 's'}`;
      
      
      // After cards render, enforce current toggle state
  applyColorwayLimitToAllCards();

    }


    
    const mini = (window.productMiniDescriptions && window.productMiniDescriptions[p.id]) || '';
    const isBacksCollection = String(handle || '').startsWith('builder-back');
let backsBadgeHTML = '';

if (isBacksCollection) {
  const st = pdBacksCardStatus(p);
  backsBadgeHTML = `<div class="pd-backs-badge ${st.done ? 'is-done' : 'is-missing'}">
    ${st.done ? '✓ Selected' : 'Required'}
  </div>`;
}
    card.innerHTML = `
      <img src="${firstImage}" alt="${p.title}">
      ${backsBadgeHTML}
      <div class="product-name">${p.title}</div>
  ${mini ? `<p class="builder26-mini-desc">${mini}</p>` : ''}
      ${
        waistlineLabel
          ? `<div class="variant-count">${waistlineLabel}</div>`
          : ''
      }

      <!-- Swatches (filled by gown-builder-swatches.js) -->
      <div class="builder26-swatch-wrap"
           data-builder-swatch-wrap
           data-builder-max-swatches="5">
        <div class="builder26-swatch-row" data-builder-swatch-row></div>
      </div>

      <div class="price">from ${moneyCents(cents)}</div>
    `;

    productGrid.appendChild(card);


 // Let the swatch module decorate this card, if loaded
if (handle !== 'builder-backs') {
  if (window.PaperDolls &&
      window.PaperDolls.swatches &&
      typeof window.PaperDolls.swatches.renderProductSwatches === 'function') {
    window.PaperDolls.swatches.renderProductSwatches(p, card);
  }
} else {
  // BACKS tab: leave the swatch area empty so spacing stays consistent
  const row = card.querySelector('[data-builder-swatch-row]');
  if (row) row.innerHTML = '';
}

  });
}


  async function loadProductVariants(handle, tabName) {
    const r = await fetch(`/products/${handle}.js`);
    const p = await r.json();
    const isBacksTab = (tabName === 'builder-backs' || tabName === 'builder-back');

    //showVariantsView();
    variantContainer.innerHTML = '';
    let renderedCount = 0;

    showVariantsView();

    const backBtn = document.createElement('button');
    backBtn.textContent = `← Back to ${tabName.replace('builder-','').toUpperCase()}`;
    backBtn.className = 'builder26-back-button';
    backBtn.style.marginBottom = '1rem';
    backBtn.onclick = () => { showProductsView(); };
    variantContainer.appendChild(backBtn);



let variantsList = (p.variants || []);

// ✅ BACKS: don't apply preview gating logic from getVisibleVariants
if (!isBacksTab &&
    window.PaperDolls &&
    window.PaperDolls.variants &&
    typeof window.PaperDolls.variants.getVisibleVariants === 'function') {
  variantsList = window.PaperDolls.variants.getVisibleVariants(p);
}

// ✅ BACKS: never color-filter
if (!isBacksTab) {
  variantsList = filterVariantsByColorways(p, variantsList);
}


  // ❌ If NO variants are visible for this product, skip the product entirely
if (!variantsList.length) {
  showProductsView();
  console.warn('[PD] No variants visible after filtering for', handle, { pdShowAllColorways });
  return;
}



 variantsList.forEach((v) => {
  // Thumbnail for the card
  const imgSrc =
    (v.featured_image && v.featured_image.src) ||
    v.image ||
    '';

// Transparent PNG for the live preview stack (NOT required on BACKS)
const previewUrlRaw =
  (window.variantPreviews && window.variantPreviews[v.id]) || '';

// For BACKS, force preview OFF entirely
const previewUrl = isBacksTab ? '' : previewUrlRaw;

// For BACKS: allow cards without preview PNGs.
// For all other tabs: require BOTH thumbnail + preview PNG.
if (!imgSrc) return;

if (!isBacksTab) {
  if (!previewUrl) return;
// ✅ Require preview PNG on every tab EXCEPT backs
if (!isBacksTab) {
  if (!previewUrlRaw) return;
}
}


  const card = document.createElement('div');
  card.className = 'builder26-option-card builder26-variant-card';
  card.dataset.productId = v.id;
  card.dataset.tab = tabName;

  // -----------------------------
// 🟣 STEP 2 — Build title + subtitle for variant card
// -----------------------------
const productName = p.title;        // parent product (e.g. "June")
const waist = v.option1 || '';      // e.g. "Natural Waist"
const opt2 = v.option2 || '';
const lining = v.option3 || '';     // e.g. "Lined" or "Sheer"

// Combine waist + lining into one subtitle line
const subtitleParts = [waist, opt2, lining].map(pdDisplayOpt).filter(Boolean);
const subtitle = subtitleParts.join(', ');

//hides "Lined" label, only display when it's "Sheer" or other
function pdDisplayOpt(val) {
  if (!val) return '';
  const s = String(val).trim();
  if (!s) return '';

  // Hide default lining
  if (s.toLowerCase() === 'lined') return '';

  return s;
}

// Format price with same logic as before
const priceText = v.price > 0 ? moneyCents(v.price) : 'No Additional Charge';

// -----------------------------
// 🟣 STEP 3 — New variant card HTML (replaces your highlighted section)
// -----------------------------
card.innerHTML = `
  <img src="${imgSrc}" alt="${productName}">
  <div class="product-name">${productName}</div>
 <div class="variant-count">
  ${waist ? `<div class="pd-opt"> ${waist}</div>` : ''}
  ${opt2 ? `<div class="pd-opt"> ${opt2}</div>` : ''}
  ${(lining && String(lining).trim().toLowerCase() !== 'lined') ? `<div class="pd-opt">${lining}</div>` : ''}
</div>
  <div class="price">${priceText}</div>
`;


    card.addEventListener('click', () => {
      const isBacksTab = (tabName === 'builder-backs' || tabName === 'builder-back');
const slotKey = isBacksTab ? pdBacksSlotKey(p) : tabName;

      // clear any previous selection in this variants view
      [...variantContainer.querySelectorAll('.builder26-option-card')]
        .forEach((c) => c.classList.remove('selected'));

      if (!isBacksTab) clearPreviewForTab(tabName);
      delete selections[slotKey];




// -----------------------------
// BACKS slot mapping (Backline / Closure / Train)
// -----------------------------
function pdBacksSlotKey(product) {
  const h = String(product?.handle || '').toLowerCase();
  const t = String(product?.title  || '').toLowerCase();

  // Prefer handle matches
  if (h.includes('backline') || t.includes('backline')) return 'backs_backline';
  if (h.includes('closure')  || t.includes('closure'))  return 'backs_closure';
  if (h.includes('train')    || t.includes('train'))    return 'backs_train';

  // If naming is odd, fall back to title keyword guesses
  if (t.includes('back')) return 'backs_backline';

  return 'backs_misc';
}

function pdBacksSlotLabel(slotKey) {
  switch (slotKey) {
    case 'backs_backline': return 'Backline';
    case 'backs_closure':  return 'Closure';
    case 'backs_train':    return 'Train';
    default:               return 'Back Detail';
  }
}



      recomputeSummary();

      card.classList.add('selected');

      const previewUrl =
        (window.variantPreviews && window.variantPreviews[v.id]) || '';

      selections[slotKey] = { 
  id: v.id,
  // Labels on Summary Accordion
   tabLabel: isBacksTab ? pdBacksSlotLabel(slotKey) : (typeof pdTabLabel === 'function' ? pdTabLabel(tabName) : tabName),
    variantLabel: (v.title || '').replace(/\s*\/\s*/g, ', '),
 opt_fabric: (() => { try { return pdGetOptionAny(p, v, ['Fabric', 'Fabric Type']); } catch(e) { return ''; } })(),
opt_color:  (() => { try { return pdGetOptionAny(p, v, ['Color', 'Colour']); } catch(e) { return ''; } })(),
opt_waist:  (() => { try { return pdGetOptionAny(p, v, ['Waistline', 'Waist', 'Waist Style', 'Waist Type']); } catch(e) { return ''; } })(),
  // ✅ NEW: a “fallback detail line” that works especially well for BACKS
  // (e.g., "Deep V + Illusion", "Lace-Up", "Sweep")
  opt_detail: (isBacksTab ? (v.title || '') : ''),
  tab: tabName,
  cents: v.price || 0,
    // ✅ NEW: Never push preview imagery for BACKS
  preview: isBacksTab ? '' : previewUrl,
};




      if (variantIdInput) variantIdInput.value = v.id;

      if (summaryInput) {
        summaryInput.value = Object.values(selections)
          .map((s) => s.title)
          .join(', ');
      }

    if (!isBacksTab) {
  pushPreviewLayer({ tab: tabName, title: v.title, previewUrl });
}

      recomputeSummary();
    });

    variantContainer.appendChild(card);
    renderedCount++;

  });
  // ✅ STEP 5 goes RIGHT HERE:
if (renderedCount === 0) {
  showProductsView();
  console.warn('[PD] No variant cards rendered (likely preview/thumbnail gating) for', handle, { pdShowAllColorways });
}


  }

  /* events */
  tabsRow.addEventListener('click', async (e) => {
    const btn = e.target.closest('.builder26-tab');
    if (!btn) return;
   // --- BACKS completion guard (only blocks when leaving BACKS) ---
const currentBtn = tabsRow.querySelector('.builder26-tab.active');
const currentCollection = currentBtn?.dataset?.collection || '';
const nextCollection = btn?.dataset?.collection || '';

const currentIsBacks = String(currentCollection).startsWith('builder-back');
const nextIsBacks = String(nextCollection).startsWith('builder-back');

if (currentIsBacks && !nextIsBacks) {
  if (!pdBacksIsComplete()) {
    const missing = pdBacksMissingSlots().join(', ');
    alert(`Finish BACK details before continuing: ${missing}`);
    return;
  }
}



if (currentIsBacks && !nextIsBacks && !pdBacksIsComplete()) {
  const missing = pdBacksMissingSlots().join(', ');
  alert(`Oops!  Make sure you select one of each back categories before continuing: ${missing}`);
  return;
}

    $$('.builder26-tab', tabsRow).forEach(t => t.classList.remove('active'));
    btn.classList.add('active');
    updateApplyButtonText();
    applyTextureFromActiveTab();
    console.log('[PD] MAIN TAB click ->', {
  tabText: btn.textContent.trim(),
  collection: btn.dataset.collection
});
    await loadCollectionProducts(btn.dataset.collection);

  });

  productContainer.addEventListener('click', async (e) => {
    const card = e.target.closest('.builder-product-trigger');
    if (!card) return;
    await loadProductVariants(card.dataset.productHandle, activeTabName());
  });

function pdMakeDesignId() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  const stamp =
    d.getFullYear() +
    pad(d.getMonth() + 1) +
    pad(d.getDate()) + '-' +
    pad(d.getHours()) +
    pad(d.getMinutes()) +
    pad(d.getSeconds());
  const rand = Math.random().toString(36).slice(2, 6).toUpperCase();
  return `PD-${stamp}-${rand}`;
}


  /* === FINAL CART ADD — MAGIC TAB ONLY === */
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      if (addToCartBtn.dataset.pdSubmitting === '1') return;
addToCartBtn.dataset.pdSubmitting = '1';
addToCartBtn.disabled = true;
addToCartBtn.classList.add('is-loading');

  // NEW: bundle key for this one design submission
  const designId = pdMakeDesignId();
      // gather all selections
      const items = [];

      // always include base product first
      if (baseProductVariantId) {
        items.push({
          id: baseProductVariantId,
          quantity: 1,
          properties: {
            Source: 'Paper Dolls Builder',
              'Design ID': designId
          }
        });
      }

      // now add each selected modular choice
      Object.values(selections).forEach(sel => {
        if (sel.tab !== 'base') {
          items.push({
            id: sel.id,
            quantity: 1,
            properties: {
               'Design ID': designId,
              'Paper Dolls Part': sel.tab.replace('builder-','').toUpperCase(),'Selection': (sel.tabLabel && sel.variantLabel)
  ? (sel.tabLabel + ': ' + sel.variantLabel)
  : (sel.title || sel.variantTitle || sel.name || sel.label || ('Variant ' + sel.id)),
  
  '_preview_image': sel.preview || sel.previewImage || sel.preview_image || sel.previewUrl || ''
            }
          });
        }
      });

try {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  });

  // If Shopify rejected it (e.g., sold out), show THAT reason.
  if (!res.ok) {
    const data = await res.json().catch(() => null);
    const msg =
      data?.description ||
      data?.message ||
      `Could not add your design to cart (error ${res.status}).`;

    alert(msg);

    // allow retry
    addToCartBtn.dataset.pdSubmitting = '0';
    addToCartBtn.disabled = false;
    addToCartBtn.classList.remove('is-loading');
    return;
  }

  // Success: go to design review pre-checkout page
  window.location.href = '/pages/paper-dolls-design-review';


} catch (err) {
  // This catch is now ONLY for true network/JS failures.
  console.error('[PD] Cart add crashed', err);
  alert('Something went wrong on this page while adding your design. Please try again.');

  // allow retry
  addToCartBtn.dataset.pdSubmitting = '0';
  addToCartBtn.disabled = false;
  addToCartBtn.classList.remove('is-loading');
}

    });
  }

  /* init sequence */
  await setBaseProduct();
  const firstTab = tabs[0];
  if (!firstTab) { console.warn('[PD] no tabs'); return; }
  firstTab.classList.add('active');
  updateApplyButtonText();
  applyTextureFromActiveTab();
  await loadCollectionProducts(firstTab.dataset.collection);

  console.log('[PD] init complete');
}

/* run on DOM ready and in theme editor */
document.addEventListener('DOMContentLoaded', () => initBuilder(document));
document.addEventListener('shopify:section:load', (e) => {
  if (e?.target?.querySelector('.pd-builder')) initBuilder(e.target);
});

/* ---------- HAMBURGER (builder menu drawer) ---------- */
document.addEventListener('click', (e) => {
  const toggle = e.target.closest('.builder26-menu-toggle');
  const closeBtn = e.target.closest('.builder26-menu-close');
  const overlay = document.getElementById('builder26-menu-overlay');
  const drawer  = document.getElementById('builder26-menu-drawer');

  if (!overlay || !drawer) return;

  // Open from hamburger
  if (toggle) {
    const willOpen = !drawer.classList.contains('is-open');
    drawer.classList.toggle('is-open', willOpen);
    overlay.classList.toggle('is-open', willOpen);
    overlay.hidden = !willOpen;
    drawer.setAttribute('aria-hidden', willOpen ? 'false' : 'true');
    return;
  }

  // Close from X button or overlay click
  if (closeBtn || e.target === overlay) {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
  }
});

// ESC key closes the builder menu
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  const overlay = document.getElementById('builder26-menu-overlay');
  const drawer  = document.getElementById('builder26-menu-drawer');
  if (!overlay || !drawer) return;
  if (!drawer.classList.contains('is-open')) return;

  drawer.classList.remove('is-open');
  overlay.classList.remove('is-open');
  overlay.hidden = true;
  drawer.setAttribute('aria-hidden', 'true');
});



/* ---------- SHOPIFY INBOX: TELEGRAM SKIN (simple + inline) ---------- */
(function () {
  function applyTelegramSkin() {
    // Only on the builder page
    const pdRoot = document.querySelector('.pd-builder');
    if (!pdRoot) return;

    // Get the image URL from your data-telegram-url attribute
    const imgUrl =
      pdRoot.dataset.telegramUrl ||
      'https://cdn.shopify.com/s/files/1/0242/8067/files/telegram.jpg?v=1760842754';

    // Shopify Inbox host + shadow root
    const host = document.querySelector('inbox-online-store-chat, shopify-chat');
    const root = host && host.shadowRoot;
    if (!root) return;

    // The actual button inside the shadow root
    const btn = root.querySelector('.chat-toggle');
    if (!btn) return;

    // Size + background image
    btn.style.width = '160px';
    btn.style.height = '90px';
    btn.style.backgroundImage = `url("${imgUrl}")`;
    btn.style.backgroundRepeat = 'no-repeat';
    btn.style.backgroundPosition = 'center';
    btn.style.backgroundSize = 'contain';
    btn.style.backgroundColor = 'transparent';
    btn.style.border = 'none';
    btn.style.borderRadius = '10px';
    btn.style.boxShadow = '0 8px 22px rgba(0,0,0,0.25)';
    btn.style.padding = '0';
    btn.style.overflow = 'hidden';
    btn.style.cursor = 'pointer';

    // Hide Shopify's default icon + text so they don't cover the art
    const title = btn.querySelector('.chat-title');
    if (title) title.style.display = 'none';

    const svg = btn.querySelector('svg');
    if (svg) svg.style.display = 'none';

    const badge = btn.querySelector('.chat-notification');
    if (badge) badge.style.display = 'none';

    console.log('[PD] Telegram skin applied');
  }

  // Keep trying for a few seconds until the widget is actually mounted
  function startTelegramSkin() {
    let tries = 0;
    const maxTries = 40; // 40 * 250ms ≈ 10s

    const iv = setInterval(() => {
      try {
        applyTelegramSkin();
      } catch (e) {
        console.warn('[PD] Telegram skin error', e);
      }

      if (++tries > maxTries) {
        clearInterval(iv);
      }
    }, 250);
  }

  document.addEventListener('DOMContentLoaded', startTelegramSkin);
})();
